<template>
    <div class="header">
        <div class="header_lfet">
            <div class="header_lfet_lfet">
                <slot name="dovlogo"> </slot>
                <img src="../assets/img/ChatLibrary-logo.png" alt="" v-if="active != 1 && active != 12"
                    @click="showSide" />
                <!-- <img v-else src="../assets/img/logoleft.png" alt="" @click="shows"/> -->
            </div>
            <div style="display: flex; align-items: center; width: calc(100% - 50px);" class="kuan_css"
                v-if="windowWidth > 565">
                <p class="move" v-if="windowWidth < actualWidth" @click="goLeft">
                    <!-- showRight && num >= 1 && windowWidth >= 1300 -->
                    <i class="el-icon-caret-left"></i>
                </p>
                <div class="header_lfet_right" id="grandfatherBox">
                    <div class="header_swiper" id="fatherBox" style="display: flex">
                        <!-- ChatLibrary 1 -->
                        <div class="header_lfet_right_item" :id="active == 2 ? 'grandsonBox' : ''"
                            v-if="role_.includes(1)">
                            <p :class="active == 2 ? 'activetitle' : ''" @click="skip_routing('ChatAnswer')">
                                ChatAnswer
                            </p>
                            <div v-if="active == 2" :class="active == 2 ? 'actives' : ''"></div>
                        </div>
                        <!-- ChatJournals 6 -->
                        <div class="header_lfet_right_item" :id="active == 8 ? 'grandsonBox' : ''"
                            v-if="role_.includes(6)">
                            <p :class="active == 8 ? 'activetitle' : ''" @click="skip_routing('ChatJournals')">
                                ChatJournals
                            </p>
                            <div v-if="active == 8" :class="active == 8 ? 'actives' : ''"></div>
                        </div>
                        <!-- ChatLanguage 2 -->
                        <div class="header_lfet_right_item" :id="active == 3 ? 'grandsonBox' : ''"
                            v-if="role_.includes(2)">
                            <p :class="active == 3 ? 'activetitle' : ''" @click="skip_routing('ChatLanguage')">
                                ChatLanguage
                            </p>
                            <div v-if="active == 3" :class="active == 3 ? 'actives' : ''"></div>
                        </div>
                        <!-- ChatFellows 3 -->
                        <div class="header_lfet_right_item" :id="active == 4 ? 'grandsonBox' : ''"
                            v-if="role_.includes(3)">
                            <p :class="active == 4 ? 'activetitle' : ''" @click="skip_routing('ChatFellows')">
                                ChatFellows
                            </p>
                            <div v-if="active == 4" :class="active == 4 ? 'actives' : ''"></div>
                        </div>
                        <!-- ChatDocuments 5 -->
                        <div class="header_lfet_right_item" :id="active == 1 ? 'grandsonBox' : ''"
                            v-if="role_.includes(5)">
                            <p :class="active == 1 ? 'activetitle' : ''" @click="skip_routing('ChatDocuments')">
                                ChatDocuments
                            </p>
                            <div v-if="active == 1" :class="active == 1 ? 'actives' : ''"></div>
                        </div>
                        <!-- ChatData 41 -->
                        <!-- <div class="header_lfet_right_item" :id="active == 12 ? 'grandsonBox' : ''"
                            v-if="role_.includes(41)">
                            <p :class="active == 12 ? 'activetitle' : ''" @click="skip_routing('ChatData')">
                                ChatData
                            </p>
                            <div v-if="active == 12" :class="active == 12 ? 'actives' : ''"></div>
                        </div> -->
                        <!-- ChatResearch 4 -->
                        <div class="header_lfet_right_item" :id="active == 5 ? 'grandsonBox' : ''"
                            v-if="role_.includes(4)">
                            <p :class="active == 5 ? 'activetitle' : ''" @click="skip_routing('ChatResearch')">
                                ChatResearch
                            </p>
                            <div v-if="active == 5" :class="active == 5 ? 'actives' : ''"></div>
                        </div>
                        <!-- ChatOpen 42 -->
                        <!-- <div class="header_lfet_right_item" :id="active == 11 ? 'grandsonBox' : ''"
                            v-if="role_.includes(42)">
                            <p :class="active == 11 ? 'activetitle' : ''" @click="skip_routing('ChatOpen')">
                                ChatOpen
                            </p>
                            <div v-if="active == 11" :class="active == 11 ? 'actives' : ''"></div>
                        </div> -->
                        <!-- ChatArchives 7 -->
                        <div class="header_lfet_right_item" :id="active == 9 ? 'grandsonBox' : ''"
                            v-if="role_.includes(7)">
                            <p :class="active == 9 ? 'activetitle' : ''" @click="skip_routing('ChatArchives')">
                                ChatArchives
                            </p>
                            <div v-if="active == 9" :class="active == 9 ? 'actives' : ''"></div>
                        </div>
                        <!-- ChatBooks 9 -->
                        <div class="header_lfet_right_item" :id="active == 10 ? 'grandsonBox' : ''"
                            v-if="role_.includes(9)">
                            <p :class="active == 10 ? 'activetitle' : ''" @click="skip_routing('ChatBooks')">
                                ChatBooks
                            </p>
                            <div v-if="active == 10" :class="active == 10 ? 'actives' : ''"></div>
                        </div>
                    </div>
                </div>
                <p class="move" v-if="windowWidth < actualWidth" @click="goRight" style="margin-right: 10px">
                    <!-- showRight && num < length - 1 && windowWidth >= 1300 -->
                    <i class="el-icon-caret-right"></i>
                </p>
            </div>
            <div class="header_lfet_right right_nav" v-if="windowWidth < 565">
                <div class="header_lfet_right_item">
                    <p class="activetitle">{{ value }}</p>
                    <div class="actives"></div>
                </div>
                <div>
                    <i class="el-icon-arrow-down" v-if="!showDown" @click="showDown = true"></i>
                    <i class="el-icon-arrow-up" v-if="showDown" @click="showDown = false"></i>
                </div>
                <div class="nav_list">
                    <transition name="el-zoom-in-top">
                        <div v-show="showDown" class="transition-box">
                            <!-- ChatLibrary 1 -->
                            <p v-if="role_.includes(1)" @click="skip_routing('ChatAnswer')"
                                :class="{ active: value == 'ChatAnswer' }">
                                ChatAnswer
                            </p>
                            <!-- ChatJournals 6 -->
                            <p v-if="role_.includes(6)" @click="skip_routing('ChatJournals')"
                                :class="{ active: value == 'ChatJournals' }">
                                ChatJournals
                            </p>
                            <!-- ChatLanguage 2 -->
                            <p v-if="role_.includes(2)" @click="skip_routing('ChatLanguage')"
                                :class="{ active: value == 'ChatLanguage' }">
                                ChatLanguage
                            </p>
                            <!-- ChatFellows 3 -->
                            <p v-if="role_.includes(3)" @click="skip_routing('ChatFellows')"
                                :class="{ active: value == 'ChatFellows' }">
                                ChatFellows
                            </p>
                            <!-- ChatDocuments 5 -->
                            <p v-if="role_.includes(5)" @click="skip_routing('ChatDocuments')"
                                :class="{ active: value == 'ChatDocuments' }">
                                ChatDocuments
                            </p>
                            <!-- ChatData 41 -->
                            <!-- <p v-if="role_.includes(41)" @click="skip_routing('ChatData')"
                                :class="{ active: value == 'ChatData' }">
                                ChatData
                            </p> -->
                            <!-- ChatResearch 4 -->
                            <p v-if="role_.includes(4)" @click="skip_routing('ChatResearch')"
                                :class="{ active: value == 'ChatResearch' }">
                                ChatResearch
                            </p>
                            <!-- ChatOpen 42 -->
                            <!-- <p v-if="role_.includes(42)" @click="skip_routing('ChatOpen')"
                                :class="{ active: value == 'ChatOpen' }">
                                ChatOpen
                            </p> -->
                            <!-- ChatArchives 7 -->
                            <p v-if="role_.includes(7)" @click="skip_routing('ChatArchives')"
                                :class="{ active: value == 'ChatArchives' }">
                                ChatArchives
                            </p>
                            <!-- ChatBooks 9 -->
                            <p v-if="role_.includes(9)" @click="skip_routing('ChatBooks')"
                                :class="{ active: value == 'ChatBooks' }">
                                ChatBooks
                            </p>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div class="admin_right">
            <langChange style="margin-right:20px"></langChange>
            <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                    <img src="../assets/img/个人中心.png" alt="">
                </span>
                <el-dropdown-menu class="top_menu" slot="dropdown" style="background:#42454b">
                    <div class="user_main">
                        <div class="top_mine" v-if="username">
                            <img src="../assets/img/个人中心.png" width="20px">
                            {{ username }}
                        </div>
                        <div v-if="organ_name" class="top_mine" style="margin-bottom:15px">
                            <p v-if="!username"><img src="../assets/img/机构.png" width="30px" style="margin:15px 0"></p>
                            {{ organ_name }}
                        </div>
                        <div style="margin-top: 20px;cursor: pointer;text-align: center;" v-if="username == '' && accountType != 4" @click="dialogVisible = true">
                            <img src="../assets/img/个人中心.png" width="20px"  style="vertical-align: middle;">
                            {{ $t('header.personal') }}
                        </div>
                    </div>
                    <el-dropdown-item style="color: #fff;text-align: center;" @click.native="feedback_"><img src="../assets/img/常见问题.png" width="18px" style="vertical-align: middle;margin-right:5px;">{{ $t('header.feedback') }}</el-dropdown-item>
                    <el-dropdown-item style="color: #fff;text-align: center;" @click.native="loginout"><img src="../assets/img/退出.png" width="18px" style="vertical-align: middle;margin-right:5px;">{{ $t('header.quit') }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <!-- <span class="quest_css" style="width: 85px" @click="feedback_"> </span> -->
            <!-- <el-tooltip effect="light" placement="bottom" v-if="username">
                <div slot="content">
                    <span style="padding: 15px 20px; cursor: pointer; font-size: 14px" @click="loginout">{{
                    $t('header.quit') }}</span>
                </div>
                <p class="admin" style="color: #fff">
                    <img src="../assets/doc/img/admin.png" alt="" /><span style="
              display: inline-block;
              max-width: 140px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            ">{{ $t('header.hello') }}，<span v-if="organ_name">{{ organ_name }}&nbsp;&nbsp;</span>{{ username }}</span>
                </p>
            </el-tooltip> -->
            <!-- <el-tooltip effect="light" placement="bottom" v-if="username == ''">
                <div slot="content">
                    <span style="padding: 15px 20px; cursor: pointer; font-size: 14px" @click="loginout">{{
                    $t('header.quit') }}</span>
                </div>
                <p style="
            color: #fff;
            cursor: pointer;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          ">
                    {{ organ_name }}
                </p>
            </el-tooltip> -->
            <!-- <span v-if="username == '' && accountType != 4" style="
          color: #fff;
          cursor: pointer;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        " @click="dialogVisible = true">&nbsp;&nbsp;|&nbsp;&nbsp;{{ $t('header.personal') }}</span>
         -->
        </div>
        <el-dialog :title="registershow == false ? $t('header.personal') : $t('header.personalAccount')"
            :visible.sync="dialogVisible"
            :width="languageType === 'Chinese' || languageType === 'zh-TW' ? '650px' : '860px'"
            :before-close="handleClose" :modal-append-to-body="false">
            <el-form v-if="registershow == false" :model="loginform" ref="post"
                :label-width="languageType == 'Chinese' && languageType == 'zh-TW' ? '80px' : '120px'">
                <el-form-item :label="$t('header.username')" prop="username">
                    <el-input v-model="loginform.username"></el-input>
                </el-form-item>
                <el-form-item :label="$t('header.password')" prop="password">
                    <el-input v-model="loginform.password" show-password></el-input>
                </el-form-item>
                <el-form-item label-width="20px">
                    <el-button type="warning" @click="login">{{ $t('header.log') }}</el-button>
                </el-form-item>
            </el-form>
            <!-- 注册 -->
            <el-form v-if="registershow == true" :model="res_form" status-icon :rules="res_rules" ref="resForm"
                class="demo-ruleForm form" key="res_form"
                :label-width="languageType == 'Chinese' || languageType == 'zh-TW' ? '120px' : languageType === 'Malay' || languageType === 'Filipino' ? '270px' : '225px'"
                style="margin: 20px 0">
                <el-form-item :label="$t('header.accountUsername') + '：'" prop="username">
                    <el-input v-model="res_form.username" autocomplete="off" :placeholder="$t('header.tips')">
                        <i slot="prefix" class="el-icon-user-solid el_icon"></i>
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('header.password') + '：'" prop="password" class="m_top_20">
                    <span slot="label">
                        <span style="color: #f56c6c; margin-right: 0px">*</span>
                        {{ $t('header.password') }}：
                    </span>
                    <el-input type="password" v-model="res_form.password" autocomplete="off"
                        :placeholder="$t('header.tipsPassword')">
                        <i slot="prefix" class="el-icon-lock el_icon"></i>
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('header.confirmPassword') + '：'" prop="checkPass" class="m_top_20">
                    <span slot="label">
                        <span style="color: #f56c6c; margin-right: 0px">*</span>
                        {{ $t('header.confirmPassword') }}：
                    </span>
                    <el-input type="password" v-model="res_form.checkPass" autocomplete="off"
                        :placeholder="$t('header.tipsConfirmPassword')">
                        <i slot="prefix" class="el-icon-lock el_icon"></i>
                    </el-input>
                </el-form-item>
                <!-- <el-form-item :label="$t('header.phone') + '：'" prop="phone" class="m_top_20">
                    <el-input v-model="res_form.phone" autocomplete="off" :placeholder="$t('header.tipsPhone')">
                        <i slot="prefix" style="font-size: 18px" class="el-icon-phone"></i>
                    </el-input>
                </el-form-item> -->
                <el-form-item :label="$t('header.email') + '：'" prop="email" class="m_top_20">
                    <el-input v-model="res_form.email" autocomplete="off" :placeholder="$t('header.tipsEmail')">
                        <i slot="prefix" class="iconfont el-icon-message"></i>
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('login.elmaiCode') + '：'" prop="code">
                    <el-input v-model="res_form.code" autocomplete="off" :placeholder="$t('header.enterCode')">
                        <i slot="prefix" class="el-icon-user-solid el_icon"></i>
                        <span slot="suffix" v-if="countdown > 0" class="el-input__icon input_code">
                            <span v-if="languageType === 'Chinese' || languageType === 'zh-TW'"><span
                                    style="color: #f56c6c">{{ countdown }}</span> {{ $t('header.again') }}</span>
                            <span v-else> {{ $t('header.again') }} <span style="color: #f56c6c">{{ countdown }}
                                </span>{{ $t('header.again2') }}</span>
                        </span>
                        <span v-else slot="suffix" @click="verify_code" class="el-input__icon input_code">{{
                    $t('header.sendVerificationCode') }}</span>
                    </el-input>
                </el-form-item>
                <div style="line-height: 1.5;font-size: 12px;color: #f56c6c;text-align: left;margin-bottom:20px;">
                    <p>*{{ $t('login.noteTitle') }}</p>
                    <p>{{ $t('login.noteOne') }}</p>
                    <p>{{ $t('login.noteTwo') }}</p>
                </div>
                <div>
                    <el-button type="primary" @click="submitResForm('resForm')">{{ $t('header.register') }}</el-button>
                </div>
            </el-form>
            <p style="text-align: right">
                <span class="input_code" v-if="registershow == true" @click="registershow = false">{{ $t('header.back')
                    }}</span>
                <span v-else>
                    {{ $t('header.noRegistered') }}？<span class="input_code" @click="registershow = true">{{
                    $t('header.register') }}</span>
                </span>
            </p>
        </el-dialog>
        <el-dialog :title="$t('header.feedback')" :visible.sync="dialogFormVisible" center
            :width="languageType === 'Chinese' || languageType === 'zh-TW' ? '600px' : '856px'" class="feed_css">
            <el-form :model="form_issue" :rules="res_rules" ref="form_issue"
                :label-width="languageType == 'Chinese' || languageType == 'zh-TW' ? '95px' : '210px'">
                <el-form-item :label="$t('header.module') + '：'" prop="model_name">
                    <el-select v-model="form_issue.model_name" :placeholder="$t('header.selectTip')"
                        style="width: 100%">
                        <el-option v-for="item in options_model" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('header.question') + '：'" prop="content">
                    <el-input type="textarea" :rows="2" v-model="form_issue.content" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item :label="$t('header.screenshot') + '：'">
                    <el-upload class="upload-demo_" ref="upload" style="width: 100%" multiple :action="action_"
                        :auto-upload="false" :show-file-list="false" :on-change="handlePreview"
                        :http-request="customUploadMethod" :limit="10" drag :file-list="fileList" accept=".jpg, .png">
                        <el-button size="small" type="primary">{{ $t('header.upload') }}</el-button>
                        <span style="margin: 0 10px; color: #f56c6c" slot="tip" class="el-upload__tip">
                            ({{ $t('header.type') }})
                        </span>
                    </el-upload>

                    <div class="upload_list" v-if="uploadedImages.length > 0">
                        <viewer :images="uploadedImages">
                            <div style="
                  display: inline-block;
                  position: relative;
                  margin: 10px 0;
                " v-for="(item, index) in uploadedImages" :key="index">
                                <i @click="delImg_(index)" class="el-icon-circle-close del_icon"></i>
                                <img :src="item" style="
                    width: 80px;
                    height: 80px;
                    margin: 0 20px 10px 0;
                    border-radius: 10px;
                  " />
                            </div>
                        </viewer>
                    </div>
                </el-form-item>

                <el-form-item :label="$t('header.email') + '：'" prop="email">
                    <el-input v-model="form_issue.email" autocomplete="off" :placeholder="$t('header.tipsEmail')">
                        <i slot="prefix" class="iconfont el-icon-message"></i>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">{{ $t('public.cancel') }}</el-button>
                <el-button type="primary" @click="submitForm('form_issue')">{{ $t('chatfellows.submit') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import store from "@/store";
import $ from "jquery";
import marked from "marked";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css"; // 引入viewer.js的CSS样式
import { sendCode, enrollAcc, getEmailCodeApi } from "@/api/classify";
import langChange from "@/components/langChange.vue";
import cityJson from '../utils/country'
export default {
    props: {
        active: {
            type: Number,
            default: "",
        },
        value: {
            type: String,
            default: "",
        },
    },
    components: {
        langChange,
    },
    data() {
        return {
            loginform: {
                // 登录表单
                username: "",
                password: "",
            },
            registeruser: {
                // 注册表单
                username: "",
                password: "",
            },
            organ_name: "",
            role_: "",
            registershow: false, // 是否显示注册表单
            accountType: "",
            username: "",
            isuserlogin: false, // 用户是否登录
            dialogVisible: false,
            showRight: false,
            num: 0,
            moveWidth: 0,
            length: 0,
            windowWidth: 0,
            showDown: false,
            dialogFormVisible: false,
            form_issue: {
                content: "",
                images: [],
                model_name: "",
                email: "",
            },
            formLabelWidth: "95px",

            imageUrl: "",
            fileList: [],
            uploadedImages: [],
            res_form: {
                username: "",
                password: "",
                checkPass: "",
                email: "",
                phone: "",
                organ_code: "",
                code: "",
                yqcode: "",
            },
            countdown: 0,
            action_: this.$root.baseURL + "/api/uploadbugimg/",
            actualWidth: 0,
            languageType: "",
            countryOptions: [],
            timer: null,
        };
    },
    created() {
        // 获取当前语种、
        if (store.getCookie("language")) {
            this.languageType = store.getCookie("language");
        } else {
            this.languageType = 'Chinese'
        }
        // if (localStorage.getItem("languageType")) {
        //     this.languageType = localStorage.getItem("languageType");
        // }
        if (localStorage.getItem("accountType")) {
            this.accountType = localStorage.getItem("accountType");
        }
        if (store.getCookie("organ_name")) {
            this.organ_name = store.getCookie("organ_name");
        }
        if (localStorage.getItem("username")) {
            this.username = localStorage.getItem("username");
            this.isuserlogin = true;
        }
        if (store.getCookie("rolePermissions")) {
            const role = this.$decryptData(store.getCookie("rolePermissions"));
            this.role_ = role.map((item) => Number(item));
        }
        this.countryOptions = cityJson.options
    },
    computed: {
        // 语言切换
        res_rules() {
            return {
                username: [
                    { required: true, message: this.$t('header.tips'), trigger: "blur" },
                ],
                password: [{ validator: (rule, value, callback) => this.validatePass(rule, value, callback), trigger: 'blur' }],
                checkPass: [{ validator: (rule, value, callback) => this.validatePass2(rule, value, callback), trigger: 'blur' }],
                email: [
                    { required: true, message: this.$t('header.tipsEmail'), trigger: "blur" },
                    {
                        type: "email",
                        message: this.$t('header.emailTip'),
                        trigger: ["blur", "change"],
                    },
                ],
                phone: [
                    { required: true, message: this.$t('header.tipsPhone'), trigger: "blur" },
                ],
                code: [{ required: true, message: this.$t('header.enterCode'), trigger: "blur" }],
            };
        },
        options_model() {
            return [
                {
                    value: "ChatAnswer",
                    label: this.$t('public.library'),
                },
                {
                    value: "ChatFellows",
                    label: this.$t('public.fellows'),
                },
                {
                    value: "ChatLanguage",
                    label: this.$t('public.language'),
                },
                {
                    value: "ChatDocuments",
                    label: this.$t('public.document'),
                },
                {
                    value: "ChatData",
                    label: this.$t('public.data'),
                },
                {
                    value: "ChatResearch",
                    label: this.$t('public.research'),
                },
                {
                    value: "其他",
                    label: this.$t('public.other'),
                },
            ]
        }
    },
    mounted() {
        this.$nextTick(() => {
            const nav = document.querySelector(".header_lfet_right");
            if (nav) {
                let seeWidth = nav.offsetWidth;
                let allWidth = nav.scrollWidth;
                if (allWidth > seeWidth) {
                    this.showRight = true;
                } else {
                    this.showRight = false;
                }
                const fatherBox = document.getElementById("fatherBox");
                const grandsonBox = document.getElementById("grandsonBox");

                // 距离
                const distanceFromGrandfather =
                    // grandsonBox.offsetLeft + grandsonBox.offsetWidth;
                    grandsonBox?.offsetLeft - fatherBox?.offsetLeft + grandsonBox?.offsetWidth;
                let num = 0
                let sun_ = (distanceFromGrandfather - seeWidth) / 150
                if (sun_ > 0 && sun_ < 1) {
                    num = Math.ceil((distanceFromGrandfather - seeWidth) / 150);
                } else {
                    num = Math.floor((distanceFromGrandfather - seeWidth) / 150);
                }
                num = Math.max(0, num);
                if (num > 0) {
                    this.num = num;
                    this.goRight();
                }
            }
            const headerSwiper = document.querySelector(".header_swiper");

            if (headerSwiper) {
                this.actualWidth = headerSwiper.offsetWidth;
            }
        });
        this.length = this.role_.length;
        // 屏幕视口宽度
        this.windowWidth = window.innerWidth - 372;
        const nav_ = document.querySelector(".header_swiper");
    },
    methods: {
        validatePass(rule, value, callback) {
            if (value === "") {
                callback(new Error(this.$t('header.tipsPassword')));
            } else if (value.length < 6 || value.length > 24) {
                callback(new Error(this.$t('header.passwordTip')));
            } else {
                if (this.res_form.checkPass !== "") {
                    this.$refs.resForm.validateField("checkPass");
                }
                callback();
            }
        },
        validatePass2(rule, value, callback) {
            if (value === "") {
                callback(new Error(this.$t('header.enterAgain')));
            } else {
                if (value !== this.res_form.password) {
                    callback(new Error(this.$t('header.inconsistent')));
                } else {
                    callback();
                }
            }
        },
        showSide() {
            this.$emit("showSide");
        },
        login() {
            this.$api.pdfupload.organ_user_login(this.loginform).then((res) => {
                if (res.data.code == 0) {
                    this.$message({
                        message: this.$t('public.loginSuccess'),
                        type: "success",
                    });
                    window.localStorage.setItem("username", res.data.data.username);
                    this.username = res.data.data.username;
                    this.isuserlogin = true;
                    this.dialogVisible = false;
                    this.loginform = {
                        username: "",
                        password: "",
                    };
                    if (this.$route.path == "/upload") {
                        this.$parent.initialization();
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning",
                    });
                }
            });
        },
        handleClose() {
            this.registershow = false;
            this.dialogVisible = false;
        },
        loginout() {
            window.localStorage.removeItem("username");
            this.username = [];
            store.clearCookie("Chat_token");
            sessionStorage.setItem("quitManual", "1");
            this.$router.push({
                path: "/",
            });
        },
        shows() {
            this.$emit("hidelist");
        },
        changePage() {
            this.$router.push(this.value);
        },
        skip_routing(type) {
            if (type == "ChatLanguage") {
                this.$router.push({ path: "/chatResearch" });
            } else if (type == "ChatResearch") {
                this.$router.push({ path: "/dashboard" });
            } else if (type === "ChatAnswer") {
                this.$router.push({ path: "/home" });
            } else if (type === "ChatDocuments") {
                this.$router.push({ path: "/ChatDocuments" });
            } else if (type === "ChatJournals") {
                this.$router.push({ path: "/journals" });
            } else if (type === 'ChatFellows') {
                this.$router.push({ path: "/chatCQUSci" });
            } else if (type === "ChatArchives") {
                this.$router.push({ path: "/chatArchives" });
            } else if (type === "ChatBooks") {
                this.$router.push({ path: "/ChatBooks" });
            } else if (type === "ChatData") {
                this.$router.push({ path: "/ChatData" });
            }
            else if (type === "ChatOpen") {
                this.$router.push({ path: "/ChatOpen" });
            }
        },
        goRight() {
            if (this.num < this.length - 1) {
                this.num++;
            } else {
                this.num = this.length - 1;
            }
            const nav = document.querySelector(".header_swiper");
            const item = document.querySelector(".header_lfet_right_item");
            const width = item.scrollWidth + 65;
            this.moveWidth = this.num * width;
            nav.style.transform = `translateX(-${this.moveWidth}px)`;
        },
        goLeft() {
            if (this.num > 1) {
                this.num--;
            } else {
                this.num = 0;
            }

            const nav = document.querySelector(".header_swiper");
            const item = document.querySelector(".header_lfet_right_item");
            const width = item.scrollWidth + 65;
            if (this.num >= 0) {
                if (this.moveWidth > 0) {
                    this.moveWidth = this.moveWidth - width;
                    this.$nextTick(() => {
                        nav.style.transform = `translateX(-${this.moveWidth}px)`;
                    });
                }
            }
        },
        registerForm() {
            this.$api.pdfupload.organ_user(this.registeruser).then((res) => {
                if (res.data.code == 0) {
                    this.$message({
                        message: this.$t('public.successful'),
                        type: "success",
                    });
                    this.registershow = false;
                    this.loginform.username = this.registeruser.username;
                    this.loginform.password = this.registeruser.password;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning",
                    });
                }
            });
        },
        feedback_() {
            this.form_issue = {
                content: "",
                images: [],
                model_name: "",
                email: "",
            };
            this.uploadedImages = [];
            this.dialogFormVisible = true;
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg" || file.type === "image/png";
            if (!isJPG) {
                this.$message.error(this.$t('header.type'));
            }
            return isJPG;
        },
        customUploadMethod() { },
        handlePreview(file, fileList) {
            let fileType = file.raw.type;
            if (fileType === "image/jpeg" || fileType === "image/png") {
                var form = new FormData();
                form.append("file", file.raw);
                this.$api.pdfupload.uploadBug(form).then((res) => {
                    if (res.data.code == 0) {
                        this.form_issue.images.push(res.data.data.filepath);
                        this.uploadedImages.push(URL.createObjectURL(file.raw));
                    }
                });
            } else {
                this.$message.error(this.$t('header.type'));
            }
            return;
        },
        getBase64Image(rawImage) {
            // 将Blob数据转换为Base64编码
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
                reader.readAsDataURL(rawImage);
            });
        },
        delImg_(i) {
            this.form_issue.images.splice(i, 1);
            this.uploadedImages.splice(i, 1);
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let form_issue_ = { ...this.form_issue };
                    form_issue_.images = JSON.stringify(form_issue_.images);
                    this.$api.pdfupload.bugFeedback(form_issue_).then((res) => {
                        if (res.data.code == 0) {
                            this.$message({
                                message: this.$t('public.feedSuccess'),
                                type: "success",
                            });
                            this.dialogFormVisible = false;
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },

        verify_code() {
            this.$refs.resForm.validateField("email", (errorMsg) => {
                if (errorMsg) {
                } else {
                    // 验证通过
                    let form = new FormData();
                    form.append("email", this.res_form.email);
                    getEmailCodeApi(form)
                        .then((res) => {
                            console.log(res, '邮箱');
                            if (res.data.code == 0) {
                                this.$message({
                                    message: this.$t('public.codeTips'),
                                    type: "success",
                                });
                                this.startCountdown();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            });
        },
        startCountdown() {
            this.countdown = 120;
            this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.timer);
                }
            }, 1000);
        },
        submitResForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let form_issue_ = {
                        username: this.res_form.username,
                        password: this.res_form.password,
                        email: this.res_form.email,
                        code: this.res_form.code,
                        organ_code: window.localStorage.getItem("organ_code_haiwai"),
                    };
                    if (localStorage.getItem('accountType') != '1') {
                        form_issue_.token = store.getCookie("Chat_token");
                    }
                    enrollAcc(form_issue_)
                        .then((res) => {
                            if (res.data.code == 0) {
                                this.$message({
                                    message: this.$t('public.successful'),
                                    type: "success",
                                });
                                this.registershow = false;
                            } else {
                                //  this.$message.error(res.data.msg);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.header {
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 50px;
    background-color: #42454b;
    padding: 0px 1rem;
    border-bottom: 1px solid #c7c7c7;
    // min-width: 1150px;
    width: 100%;

    .header_lfet {
        display: flex;
        color: #fff;
        font-weight: 100;
        height: 66%;
        align-items: center;
        max-width: calc(100% - 10.5rem - 105px);

        .header_lfet_right::-webkit-scrollbar {
            display: none;
        }

        .header_lfet_lfet {
            margin-right: 10px;

            img {
                width: 25px;
                cursor: pointer;
            }
        }

        .header_lfet_right {
            display: flex;
            align-items: center;
            // margin-left: 20px;
            height: 100%;
            overflow: auto;
            // background-color: #E6A23C;
            // margin-right: 1rem;

            .header_lfet_right_item {
                cursor: pointer;
                margin: 0 30px;
                font-size: 14px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 100%;

                div {
                    width: 50px;
                    margin-top: 5px;
                    height: 3px;
                    background: #42454b;
                }

                .activetitle {
                    font-size: 14px;
                    font-weight: 600;
                }

                .actives {
                    width: 50px;
                    height: 3px;
                    background: #fff;
                    border-radius: 5px;
                }

                p {
                    white-space: nowrap;
                }
            }

            // img {
            //   height: 50px;
            //   cursor: pointer;
            // }
        }
    }

    .move {
        cursor: pointer;
    }
}

.nav_list {
    position: absolute;
    top: 56px;
    left: 0.5rem;
}

.transition-box {
    margin-top: -10px;
    margin-bottom: 10px;
    width: 8rem;
    // height: 110px;
    border-radius: 4px;
    padding: 0.2rem 1rem;
    background-color: #42454b;
    text-align: center;
    color: #fff;
    // padding: 40px 20px;
    text-align: left;
    box-sizing: border-box;
    margin-right: 20px;
    overflow: auto;

    p {
        margin: 0.7rem 0;
        font-size: 0.6rem;
    }

    p:hover {
        color: #e6a23c;
    }

    .active {
        color: #e6a23c;
    }
}

.right_nav {
    overflow: visible !important;
    position: relative;
}

.admin_right {
    display: flex;
    align-items: center;
    // width: 10.5rem;
    text-align: right;
    width: max-content;
    flex-wrap: nowrap;

    span {
        height: 15px;
    }

    p {
        height: 15px;
    }
}


.admin {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 20px;
        margin-right: 10px;
    }
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    border: #e6a23c;
    background: #e6a23c;
}

/deep/ .el-radio__input.is-checked+.el-radio__label {
    color: #e6a23c;
}

/deep/ .el-radio__inner:hover {
    border-color: #e6a23c;
}

/deep/ .el-button--primary {
    border-color: #e6a23c;
    background-color: #e6a23c;
}

/deep/ .el-button--warning {
    border-color: #e6a23c;
    background-color: #e6a23c;
}

/deep/ .el-button--primary:hover {
    background: #e6a23c;
    border-color: #e6a23c;
    // color: #333;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #e6a23c;
    background-color: #e6a23c;
}

/deep/ .el-checkbox-group {
    text-align: left;
}

/deep/ .el-checkbox__inner:hover {
    border-color: #e6a23c;
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #e6a23c;
}

/deep/ .el-dialog__headerbtn:hover .el-dialog__close {
    color: #e6a23c;
}

/deep/ .el-upload-dragger:hover {
    border-color: #e6a23c;
}

.quest_css {
    margin: 0 10px 0 5px;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.quest_css:hover {
    cursor: pointer;
    //   color: #409eff;
    font-weight: 600;
}

.feed_css {
    /deep/ .el-upload {
        width: auto !important;
    }

    /deep/ .el-upload-dragger {
        width: auto !important;
        height: auto !important;
        border: none !important;
    }
}

/deep/ .upload-demo_ {
    display: flex;
    align-items: center;
}

.del_icon {
    position: absolute;
    top: -2px;
    right: 15px;
}

.del_icon:hover {
    color: #409eff;
    cursor: pointer;
}

.input_code:hover {
    color: #409eff;
    cursor: pointer;
}

/deep/ .el-form-item__label {
    word-break: break-word;
}
</style>
<style>
.el-dropdown-menu[x-placement^=bottom] .popper__arrow::after{
    border-bottom-color: #42454b !important;
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background: #42454b !important;
}
.user_main{
    padding: 0 20px;
    color: #fff;
    max-width: 300px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 15px;
    padding-bottom: 10px;
}
.user_main .top_mine{
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
}
.user_main .top_mine img{
    vertical-align: middle;
}
</style>

<!-- 小屏适配 -->
<style lang="less" scoped>
/deep/ .el-dropdown-menu{
    background: #42454b;
}
@media screen and (max-width: 860px) {
    .header_lfet_right_item {
        font-size: 0.7rem !important;
        margin: 0 1rem !important;
    }

    .header {
        padding: 0 0.9rem;

        .header_lfet {
            width: calc(100% - 140px) !important;

            .header_lfet_lfet {
                img {
                    width: 1.5rem;
                }
            }

            .header_lfet_right {
                // margin-left: 1rem;
            }
        }

        .admin_right {
            // min-width: 150px !important;
            font-size: 0.7rem !important;
        }
    }
}

@media screen and (max-width: 630px) {
    .header_lfet_right_item {
        font-size: 0.6rem !important;
        margin: 0 0.8rem !important;
    }

    .header {
        padding: 0 0.7rem;

        .header_lfet {
            .header_lfet_lfet {
                img {
                    width: 1.2rem;
                }
            }

            .header_lfet_right {
                width: calc(100% - 3.4rem);
                // margin-left: 0.8rem;
                overflow: auto;
            }
        }

        .admin_right {
            font-size: 0.6rem !important;
        }
    }
}

@media screen and (max-width: 565px) {
    .header {
        overflow: visible !important;

        .header_lfet {
            overflow: visible !important;
        }

        .nav_list {
            z-index: 2;
        }
    }
}
</style>